// extracted by mini-css-extract-plugin
export default {"container":"FeatureContainer_container__HnNDW","glide-up":"FeatureContainer_glide-up__gIZgE"};